import { Notice } from "../../components/Notice";
import { useKaya } from "../../store/kayaStore";

/**
 * What an admin previewing the app as a normal user sees where the admin screens would be.
 *
 * Deliberately *content* and not an `IonPage`. A route component that swaps which `IonPage`
 * element it returns leaves the router outlet holding a page it no longer tracks: the discarded
 * one stayed visible, so this notice appeared on top of the settings hub, the hub underneath it
 * was unreachable, and nothing would navigate away. One page per route, always — only what is
 * inside it changes.
 */
export function UserViewNotice() {
  const setViewAsUser = useKaya((s) => s.setViewAsUser);
  return (
    <Notice primary={{ label: "Switch back to admin", onClick: () => setViewAsUser(false) }}>
      You are viewing Kaya as a normal user, so the admin screens are hidden.
    </Notice>
  );
}
